import type { Editor } from 'slate';

import type { DrawInstruction } from './draw-instruction';
import type { RenderOptions } from './rendering-data';
import type { NodeBoundingBox, RenderModelPage } from '../../slate-api';

export abstract class AbstractRenderer {
  protected editor: Editor;

  constructor(editor: Editor) {
    this.editor = editor;
  }

  abstract render(
    pageBoundingBox: NodeBoundingBox<RenderModelPage>,
    options: Omit<RenderOptions, 'rMPath'>
  ): DrawInstruction[];
}
